<template>
  <div class="ph-special-main ">
    <el-backtop ></el-backtop>
    <hpheader v-if="showHeader"></hpheader>

<!--    <div class="special-body">-->
<!--      <position-bar :positionNav="positionNav">-->
<!--      </position-bar>-->
<!--      <div class="banner-container" ref="bannerContainerRef">-->
<!--&lt;!&ndash;        <div class="banner" ref="bannerRef">&ndash;&gt;-->
<!--&lt;!&ndash;          <img  @load="onImageLoad" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251231/8c7e32af5822565a4c8988373bace305.jpg" alt="">&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--        <div class="banner" ref="bannerRef">-->
<!--          <img  src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260125/fed8906ffd3524329bb617f143ccfd3d.jpg" alt="">-->
<!--          <p class="banner-title">The Future of Endodontics</p>-->
<!--          <img @load="onImageLoad" class="product-banner"  src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260125/e56fe44960d9a0ba6e466d8e052f3c4c.png" alt="">-->
<!--        </div>-->
<!--        <div class="preview-video-container" ref="previewVideoContainerRef">-->
<!--&lt;!&ndash;          <div class="preview-video-box" ref="previewVideoBoxRef">&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--          <div class="preview-video-text pl-100 pr-100" ref="previewVideoTextRef">-->
<!--            <h4>TorqueSense™: Real-Time Torque Control</h4>-->
<!--            <h4>ClearSignal™: Signal Quality Indicator</h4>-->
<!--            <h4>Customizable "Build-Your-File" feature</h4>-->
<!--            <h4>Cordless freedom & HD Touchscreen</h4>-->
<!--            <endo-button @onclick="openVideoModal(videoList[0].previewVideo)"></endo-button>-->
<!--          </div>-->
<!--          <div class="preview-video-box">-->
<!--            <div class="progress">-->
<!--              <circular-progress :progress="videoList[0].progress" :isPlaying="videoList[0].playing" index="0" @togglePlay="togglePlay"/>-->
<!--            </div>-->
<!--            <video class="background-video"-->
<!--                   :ref="videoList[0].ref"-->
<!--                   :src="videoList[0].video"-->
<!--                   muted-->
<!--                   playsinline-->
<!--                   loop-->
<!--                   autoplay-->
<!--            ></video>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="section-product-desc">-->
<!--        <div class="product-logo">-->
<!--          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/87e903851c3d897212cbc769f7cbf820.png" alt="">-->
<!--        </div>-->
<!--        <div class="product-logo-text">-->
<!--          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/67e1d823677d4b4c5aff4dcee4305af0.png" alt="">-->
<!--        </div>-->
<!--        <div class="product-image">-->
<!--          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251231/8bd325f95eeb52a77358086b920657f5.jpg" alt="">-->
<!--        </div>-->
<!--        <div class="product-special-title pl-100 pr-100">-->
<!--          <div class="product-special-title-b">-->
<!--            <h5>A real-time intelligent</h5>-->
<!--            <h5>torque setting</h5>-->
<!--            <p>Inspired by Dr. Carlos Spirinelli Ramos</p>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="product-detail-text1 pl-100 pr-100">-->
<!--          <p class="txt">-->
<!--            Woodpecker has introduced an innovative system-->
<!--            for real-time torque determination that analyzes-->
<!--            the cutting resistance of files against the dentin-->
<!--            wall. The Endo GT Series learns the torque needed-->
<!--            to cut through dentin and automatically adjusts to-->
<!--            set the ideal torque for each section of the canal.-->
<!--            This ensures that cutting power is tailored to the-->
<!--            task while protecting against torsional fatigue and-->
<!--            file separation.-->
<!--          </p>-->
<!--&lt;!&ndash;          <p class="txt">for real-time torque determination that analyzes</p>&ndash;&gt;-->
<!--&lt;!&ndash;          <p class="txt">the cutting resistance of files against the dentin</p>&ndash;&gt;-->
<!--&lt;!&ndash;          <p class="txt">wall. The Endo GT Series learns the torque needed</p>&ndash;&gt;-->
<!--&lt;!&ndash;          <p class="txt">to cut through dentin and automatically adjusts to</p>&ndash;&gt;-->
<!--&lt;!&ndash;          <p class="txt">set the ideal torque for each section of the canal.</p>&ndash;&gt;-->
<!--&lt;!&ndash;          <p class="txt">This ensures that cutting power is tailored to the</p>&ndash;&gt;-->
<!--&lt;!&ndash;          <p class="txt">task while protecting against torsional fatigue and</p>&ndash;&gt;-->
<!--&lt;!&ndash;          <p class="txt">file separation.</p>&ndash;&gt;-->
<!--          <endo-button @onclick="openVideoModal(videoList[1].previewVideo)"></endo-button>-->
<!--        </div>-->

<!--        <div class="product-video-container">-->
<!--          <div class="progress">-->
<!--            <circular-progress :progress="videoList[1].progress" :isPlaying="videoList[1].playing" index="1" @togglePlay="togglePlay"/>-->
<!--          </div>-->
<!--          <video class="product-video"-->
<!--                 :ref="videoList[1].ref"-->
<!--                 :src="videoList[1].video"-->
<!--                 muted-->
<!--                 playsinline-->
<!--                 loop-->
<!--                 autoplay-->
<!--          ></video>-->
<!--        </div>-->

<!--        <div class="product-detail-text1 product-detail-text2 pl-100 pr-100">-->
<!--          <p class="txt">The motor detects torque in real time and</p>-->
<!--          <p class="txt">establishes the ideal safety threshold based on the</p>-->
<!--          <p class="txt">file's cutting surface area.</p>-->

<!--          <p class="txt mt-77">The proprietary technology automatically switches</p>-->
<!--          <p class="txt">to a safe right-cutting reciprocating mode when</p>-->
<!--          <p class="txt">torque exceeds the set threshold.</p>-->

<!--          <p class="txt mt-77">There is no need to pre-set torque values for</p>-->
<!--          <p class="txt">different files.</p>-->
<!--        </div>-->

<!--        <div class="step-list pl-100 pr-100">-->
<!--          <div class="step-item video-container">-->
<!--&lt;!&ndash;            <div class="progress">&ndash;&gt;-->
<!--&lt;!&ndash;              <circular-progress :progress="videoList[2].progress" :isPlaying="videoList[2].playing" index="2" @togglePlay="togglePlay"/>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;            <video class="step-video-1"&ndash;&gt;-->
<!--&lt;!&ndash;                   :ref="videoList[2].ref"&ndash;&gt;-->
<!--&lt;!&ndash;                   :src="videoList[2].video"&ndash;&gt;-->
<!--&lt;!&ndash;                   muted&ndash;&gt;-->
<!--&lt;!&ndash;                   playsinline&ndash;&gt;-->
<!--&lt;!&ndash;                   loop&ndash;&gt;-->
<!--&lt;!&ndash;                   autoplay&ndash;&gt;-->
<!--&lt;!&ndash;            ></video>&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="step-video-txt">&ndash;&gt;-->
<!--&lt;!&ndash;              <div class="step-video-title">&ndash;&gt;-->
<!--&lt;!&ndash;                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/80bfd42f39c7d492f9f16532b6d21d57.png" alt="">&ndash;&gt;-->
<!--&lt;!&ndash;                <h5>Step 1</h5>&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--&lt;!&ndash;              <p class="txt-big mt-15">2<span class="txt-middle">s</span></p>&ndash;&gt;-->
<!--&lt;!&ndash;              <p class="txt-small">Learning</p>&ndash;&gt;-->
<!--&lt;!&ndash;              <p class="txt-small">torque</p>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--            <div class="step-image">-->
<!--              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260123/ed2b80d6f138960037b8d5c506f01646.png" alt=""></img>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="step-item video-container">-->
<!--&lt;!&ndash;            <div class="progress">&ndash;&gt;-->
<!--&lt;!&ndash;              <circular-progress :progress="videoList[3].progress" :isPlaying="videoList[3].playing" index="3" @togglePlay="togglePlay"/>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;            <video class="step-video-2"&ndash;&gt;-->
<!--&lt;!&ndash;                   :ref="videoList[3].ref"&ndash;&gt;-->
<!--&lt;!&ndash;                   :src="videoList[3].video"&ndash;&gt;-->
<!--&lt;!&ndash;                   muted&ndash;&gt;-->
<!--&lt;!&ndash;                   playsinline&ndash;&gt;-->
<!--&lt;!&ndash;                   loop&ndash;&gt;-->
<!--&lt;!&ndash;                   autoplay&ndash;&gt;-->
<!--&lt;!&ndash;            ></video>&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="step-video-txt">&ndash;&gt;-->
<!--&lt;!&ndash;              <div class="step-video-title">&ndash;&gt;-->
<!--&lt;!&ndash;                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/80bfd42f39c7d492f9f16532b6d21d57.png" alt="">&ndash;&gt;-->
<!--&lt;!&ndash;                <h5>Step 2</h5>&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--&lt;!&ndash;              <p class="txt-small mt-25">Auto-set</p>&ndash;&gt;-->
<!--&lt;!&ndash;              <p class="txt-small">the ideal</p>&ndash;&gt;-->
<!--&lt;!&ndash;              <p class="txt-small">torque</p>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--            <div class="step-image">-->
<!--              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260123/0a602ba8a39a8b23ff3f93376581d3fa.png" alt=""></img>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="step-item video-container">-->
<!--&lt;!&ndash;            <div class="progress">&ndash;&gt;-->
<!--&lt;!&ndash;              <circular-progress :progress="videoList[4].progress" :isPlaying="videoList[4].playing" index="4" @togglePlay="togglePlay"/>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;            <video class="step-video-3"&ndash;&gt;-->
<!--&lt;!&ndash;                   :ref="videoList[4].ref"&ndash;&gt;-->
<!--&lt;!&ndash;                   :src="videoList[4].video"&ndash;&gt;-->
<!--&lt;!&ndash;                   muted&ndash;&gt;-->
<!--&lt;!&ndash;                   playsinline&ndash;&gt;-->
<!--&lt;!&ndash;                   loop&ndash;&gt;-->
<!--&lt;!&ndash;                   autoplay&ndash;&gt;-->
<!--&lt;!&ndash;            ></video>&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="step-video-txt">&ndash;&gt;-->
<!--&lt;!&ndash;              <div class="step-video-title">&ndash;&gt;-->
<!--&lt;!&ndash;                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251215/80bfd42f39c7d492f9f16532b6d21d57.png" alt="">&ndash;&gt;-->
<!--&lt;!&ndash;                <h5>Step 3</h5>&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--&lt;!&ndash;              <p class="txt-small mt-25">Reciprocation</p>&ndash;&gt;-->
<!--&lt;!&ndash;              <p class="txt-small">if torque is</p>&ndash;&gt;-->
<!--&lt;!&ndash;              <p class="txt-small">surpassed</p>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--            <div class="step-image">-->
<!--              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260123/81ccc351f0cdf3994d4931df92510e04.png" alt=""></img>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="section-product-suit section-product-desc">-->
<!--        <div class="product-logo">-->
<!--          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251216/fd75dc0a2eb9cc522f4458e6482640d0.png" alt="">-->
<!--        </div>-->
<!--        <div class="product-logo-text">-->
<!--          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251216/ef9dacf873710fd3a4777acd9297cc29.png" alt="">-->
<!--        </div>-->
<!--        <div class="product-special-title pl-100 pr-100">-->
<!--          <div class="product-special-title-b">-->
<!--            <h5>A powerful aid for electronic</h5>-->
<!--            <h5>readings accuracy</h5>-->
<!--            <p>Inspired by Dr. Carlos Spirinelli Ramos</p>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="product-detail-text1 pl-100 pr-100">-->
<!--          <p class="txt">-->
<!--            Unstable or inconsistent electronic measurements-->
<!--            can lead to inaccurate readings. ClearSignal™-->
<!--            technology evaluates the strength of the electronic-->
<!--            signal, helping determine whether the connection is-->
<!--            reliable for accurately locating the foramen exit.-->
<!--          </p>-->
<!--&lt;!&ndash;          <p class="txt">can lead to inaccurate readings. ClearSignal™</p>&ndash;&gt;-->
<!--&lt;!&ndash;          <p class="txt">technology evaluates the strength of the electronic</p>&ndash;&gt;-->
<!--&lt;!&ndash;          <p class="txt">signal, helping determine whether the connection is</p>&ndash;&gt;-->
<!--&lt;!&ndash;          <p class="txt">reliable for accurately locating the foramen exit.</p>&ndash;&gt;-->
<!--          <endo-button @onclick="openVideoModal(videoList[5].previewVideo)"></endo-button>-->
<!--        </div>-->

<!--        <div class="g-preview-video-container product-video-container">-->
<!--&lt;!&ndash;          <div class="progress">&ndash;&gt;-->
<!--&lt;!&ndash;            <circular-progress :progress="videoList[5].progress" :isPlaying="videoList[5].playing" index="5" @togglePlay="togglePlay"/>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;          <video class="g-preview-video product-video"&ndash;&gt;-->
<!--&lt;!&ndash;                 :ref="videoList[5].ref"&ndash;&gt;-->
<!--&lt;!&ndash;                 :src="videoList[5].video"&ndash;&gt;-->
<!--&lt;!&ndash;                 muted&ndash;&gt;-->
<!--&lt;!&ndash;                 playsinline&ndash;&gt;-->
<!--&lt;!&ndash;                 loop&ndash;&gt;-->
<!--&lt;!&ndash;                 autoplay&ndash;&gt;-->
<!--&lt;!&ndash;          ></video>&ndash;&gt;-->
<!--          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260123/9c23d06af668398f4938108855ca1e13.jpg" alt="">-->
<!--        </div>-->

<!--        <div class="product-detail-text1 product-detail-text2 product-detail-text3 pl-100 pr-100">-->
<!--          <p class="txt">Displays real-time electronic signal strength</p>-->
<!--          <p class="txt">Taps the center dial for instant on-screen alerts</p>-->
<!--          <p class="txt">and guidance</p>-->
<!--        </div>-->

<!--        <div class="g-mode-video-container product-video-container">-->
<!--          <div class="progress">-->
<!--            <circular-progress :progress="videoList[6].progress" :isPlaying="videoList[6].playing" index="6" @togglePlay="togglePlay"/>-->
<!--          </div>-->
<!--          <video class="g-mode-video product-video"-->
<!--                 :ref="videoList[6].ref"-->
<!--                 :src="videoList[6].video"-->
<!--                 muted-->
<!--                 playsinline-->
<!--                 loop-->
<!--                 autoplay-->
<!--          ></video>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="improved-container">-->
<!--        <div class="improved-banner-text pl-100 pr-100">-->
<!--          <div class="product-special-title">-->
<!--            <div class="product-special-title-b">-->
<!--              <h5>Improved handpiece</h5>-->
<!--              <h5>response</h5>-->
<!--            </div>-->
<!--            <div class="product-special-title-p">-->
<!--              <p>The Endo GT Series leads the way with advanced</p>-->
<!--              <p>handpiece control technology, ensuring</p>-->
<!--              <p>reciprocation angles align precisely with today's</p>-->
<!--              <p>diverse file specifications.</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="improved-banner">-->
<!--          <img @load="onImprovedBanner" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260102/660f8002e2ec712d55eaceb9a66012e4.jpg" alt="">-->
<!--        </div>-->
<!--        <div class="improved-content pl-100 pr-100" ref="improvedContentRef">-->
<!--          <div class="product-special-title">-->
<!--            <div class="product-special-title-b">-->
<!--              <h5>Multiple protections</h5>-->
<!--              <h5>for safer and more</h5>-->
<!--              <h5>controlled canal preparation</h5>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="improved-content-detail">-->
<!--            <div class="product-special-title">-->
<!--              <div class="product-special-title-b">-->
<!--                <h5>Apex-driven monitoring system</h5>-->
<!--              </div>-->
<!--              <div class="product-special-title-p">-->
<!--                <p>Sync audio-visual feedback: The audible alarm</p>-->
<!--                <p>gradually intensifies as the file approaches the</p>-->
<!--                <p>apical alarm, and emits a continuous tone with</p>-->
<!--                <p>the LED flashing upon reaching it.</p>-->
<!--                <p>Dynamic progress tracking: On-screen apex</p>-->
<!--                <p>indicator bar shows real-time file progress inside</p>-->
<!--                <p>the canal.</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="product-special-title">-->
<!--              <div class="product-special-title-b">-->
<!--                <h5>Intelligent preset control system</h5>-->
<!--              </div>-->
<!--              <div class="product-special-title-p">-->
<!--                <p>Auto Start/Stop: File starts and stops</p>-->
<!--                <p>automatically as it enters or exits the canal.</p>-->
<!--                <p>Auto Slowdown: File slows down automatically as</p>-->
<!--                <p>it approaches the apical alarm.</p>-->
<!--                <p>Auto Reverse/Stop: File reverses or stops rotation</p>-->
<!--                <p>automatically upon reaching the apical alarm.</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

<!--&lt;!&ndash;        <div class="improved-content" ref="improvedContentRef">&ndash;&gt;-->
<!--&lt;!&ndash;          <div class="torque-sense">&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="torque-sense-logo">&ndash;&gt;-->
<!--&lt;!&ndash;              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251216/8da99d7895634c11c0388d0b4b68907a.png" alt="">&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="product-special-title">&ndash;&gt;-->
<!--&lt;!&ndash;              <div class="product-special-title-b">&ndash;&gt;-->
<!--&lt;!&ndash;                <h5>TorqueSense</h5>&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--&lt;!&ndash;              <div class="product-special-title-p">&ndash;&gt;-->
<!--&lt;!&ndash;                <p>Effortless torque</p>&ndash;&gt;-->
<!--&lt;!&ndash;                <p>control with precise</p>&ndash;&gt;-->
<!--&lt;!&ndash;                <p>adjustments</p>&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;          <div class="atr-mode">&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="atr-mode-logo">&ndash;&gt;-->
<!--&lt;!&ndash;              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251216/173dba0a4e426292c168e6b19dcad79b.png" alt="">&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="product-special-title">&ndash;&gt;-->
<!--&lt;!&ndash;              <div class="product-special-title-b">&ndash;&gt;-->
<!--&lt;!&ndash;                <h5>ATR Mode</h5>&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--&lt;!&ndash;              <div class="product-special-title-p">&ndash;&gt;-->
<!--&lt;!&ndash;                <p>Reciprocation is ignited</p>&ndash;&gt;-->
<!--&lt;!&ndash;                <p>when the torque is</p>&ndash;&gt;-->
<!--&lt;!&ndash;                <p>surpassedas a safety feature</p>&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--      </div>-->

<!--      <div class="contra-angle-container">-->
<!--        <div class="contra-angle-box">-->
<!--          <div class="contra-angle-banner-text pr-100 pl-100">-->
<!--            <div class="product-special-title">-->
<!--              <div class="product-special-title-b">-->
<!--                <h5>8 mm</h5>-->
<!--                <h5>diameter</h5>-->
<!--              </div>-->
<!--              <div class="product-special-title-p">-->
<!--                <p>Ultra-slim 8 mm head for superior access</p>-->
<!--                <p>to posterior teeth</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="contra-angle-banner-animate-box">-->
<!--          <div class="contra-angle-banner">-->
<!--            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260102/747c18d6e68bcd7e2b74f68ea0e5ddfc.jpg" alt=""/>-->
<!--            <div class="contra-angle-banner-text pl-100 pr-100">-->
<!--              <div class="product-special-title">-->
<!--                <div class="product-special-title-b">-->
<!--                  <h5>Contra-angle head</h5>-->
<!--                  <h5>with LED light</h5>-->
<!--                </div>-->
<!--                <div class="flex contra-angle-parameter">-->
<!--                  <div class="bottom-align">-->
<!--                    <div class="product-special-title-b">-->
<!--                      <h5 style="vertical-align: bottom;">≥8000</h5>-->
<!--                    </div>-->
<!--                    <div class="product-special-title-p">-->
<!--                      <p>lux</p>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="product-special-title-p contra-angle-desc">-->
<!--                  <p>Adjustable cold light for shadow-free illumination</p>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            &lt;!&ndash;          <div class="contra-angle-banner-text">&ndash;&gt;-->
<!--            &lt;!&ndash;            <div class="product-special-title">&ndash;&gt;-->
<!--            &lt;!&ndash;              <div class="product-special-title-b">&ndash;&gt;-->
<!--            &lt;!&ndash;                <h5>Contra-angle</h5>&ndash;&gt;-->
<!--            &lt;!&ndash;                <h5>head with</h5>&ndash;&gt;-->
<!--            &lt;!&ndash;                <h5>LED light</h5>&ndash;&gt;-->
<!--            &lt;!&ndash;              </div>&ndash;&gt;-->
<!--            &lt;!&ndash;              <div class="flex contra-angle-parameter">&ndash;&gt;-->
<!--            &lt;!&ndash;                <div class="bottom-align">&ndash;&gt;-->
<!--            &lt;!&ndash;                  <div class="product-special-title-b">&ndash;&gt;-->
<!--            &lt;!&ndash;                    <h5 style="vertical-align: bottom;">8000</h5>&ndash;&gt;-->
<!--            &lt;!&ndash;                  </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                  <div class="product-special-title-p">&ndash;&gt;-->
<!--            &lt;!&ndash;                    <p>lux</p>&ndash;&gt;-->
<!--            &lt;!&ndash;                  </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                <div class="bottom-align">&ndash;&gt;-->
<!--            &lt;!&ndash;                  <div class="product-special-title-b">&ndash;&gt;-->
<!--            &lt;!&ndash;                    <h5>8 mm</h5>&ndash;&gt;-->
<!--            &lt;!&ndash;                  </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                  <div class="product-special-title-p">&ndash;&gt;-->
<!--            &lt;!&ndash;                    <p>diameter</p>&ndash;&gt;-->
<!--            &lt;!&ndash;                  </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                </div>&ndash;&gt;-->
<!--            &lt;!&ndash;              </div>&ndash;&gt;-->
<!--            &lt;!&ndash;              <div class="product-special-title-p contra-angle-desc">&ndash;&gt;-->
<!--            &lt;!&ndash;                <p>Ultra-slim 8 mm head for superior access</p>&ndash;&gt;-->
<!--            &lt;!&ndash;                <p>to posterior teeth</p>&ndash;&gt;-->
<!--            &lt;!&ndash;                <p>Adjustable cold light for shadow-free illumination</p>&ndash;&gt;-->
<!--            &lt;!&ndash;              </div>&ndash;&gt;-->
<!--            &lt;!&ndash;            </div>&ndash;&gt;-->
<!--            &lt;!&ndash;          </div>&ndash;&gt;-->
<!--          </div>-->
<!--          <div class="contra-angle-animation">-->
<!--            &lt;!&ndash;          <div class="contra-angle-slider">&ndash;&gt;-->
<!--            &lt;!&ndash;            <i class="dark">&ndash;&gt;-->
<!--            &lt;!&ndash;              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251217/791eea63527aa78c4a20687435031129.png" alt="">&ndash;&gt;-->
<!--            &lt;!&ndash;            </i>&ndash;&gt;-->
<!--            &lt;!&ndash;            <el-slider v-model="contraAngleSliderValue" :show-tooltip="false" :max="contraAngleBanner.length" @input="listenMove"></el-slider>&ndash;&gt;-->
<!--            &lt;!&ndash;            <i class="light">&ndash;&gt;-->
<!--            &lt;!&ndash;              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251217/234999d86aa2515b99003560dc84cb3e.png" alt="">&ndash;&gt;-->
<!--            &lt;!&ndash;            </i>&ndash;&gt;-->
<!--            &lt;!&ndash;          </div>&ndash;&gt;-->
<!--            <div class="contra-angle-animation-container pl-100 pr-100">-->
<!--              <img ref="contraAngleAnimationRef" :src="contraAngleBanner[0]" alt="">-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="gradient-background">-->
<!--        <div class="section-build-file">-->
<!--          <div class="pr-100 pl-100">-->
<!--            <div class="product-special-title">-->
<!--              <div class="product-special-title-b">-->
<!--                <h5>Build you file</h5>-->
<!--                <p>Inspired by Dr. Carlos Spirinelli Ramos</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="product-detail-text1">-->
<!--              <p class="txt">The Endo GT series enables users to build files and</p>-->
<!--              <p class="txt">sequences using an intuitive, user-friendly interface.</p>-->

<!--              <p class="txt mt-77">Create your file based on specifications such as tip,</p>-->
<!--              <p class="txt">taper, color identification, and additional</p>-->
<!--              <p class="txt">parameters.</p>-->
<!--              <p class="txt">Generate a sequence of hybrid files using various</p>-->
<!--              <p class="txt">brands from the library or those created by the</p>-->
<!--              <p class="txt">operator.</p>-->
<!--              <p class="txt">Develop distinct sequences for various scenarios,</p>-->
<!--              <p class="txt">includingglide path, MB2, large canals, and more.</p>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="section-product-desc">-->
<!--            <div class="build-file-video-container product-video-container">-->
<!--              <div class="progress">-->
<!--                <circular-progress :progress="videoList[7].progress" :isPlaying="videoList[7].playing" index="7" @togglePlay="togglePlay"/>-->
<!--              </div>-->
<!--              <video class="build-file-video product-video"-->
<!--                     :ref="videoList[7].ref"-->
<!--                     :src="videoList[7].video"-->
<!--                     muted-->
<!--                     playsinline-->
<!--                     loop-->
<!--                     autoplay-->
<!--              ></video>-->
<!--            </div>-->
<!--          </div>-->

<!--        </div>-->

<!--        <div class="selection-magnetic">-->
<!--          <div class="product-special-title pl-100 pr-100">-->
<!--            <div class="product-special-title-b">-->
<!--              <h5>Cordless freedom</h5>-->
<!--              <h5>with magnetic docking</h5>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="product-detail-text1 pl-100 pr-100">-->
<!--            <p class="txt">The handpiece and base are cordless and connected</p>-->
<!--            <p class="txt">with Bluetooth® technology. Magnetic docking easily</p>-->
<!--            <p class="txt">connects the handpiece base to the main unit for</p>-->
<!--            <p class="txt">convenient handling with wirelss recharging.</p>-->
<!--          </div>-->
<!--          <div class="section-product-desc">-->
<!--            <div class="magnetic-video-container product-video-container ">-->

<!--              <div class="progress">-->
<!--                <circular-progress :progress="videoList[8].progress" :isPlaying="videoList[8].playing" index="8" @togglePlay="togglePlay"/>-->
<!--              </div>-->
<!--              <video class="magnetic-video product-video"-->
<!--                     :ref="videoList[8].ref"-->
<!--                     :src="videoList[8].video"-->
<!--                     muted-->
<!--                     playsinline-->
<!--                     loop-->
<!--                     autoplay-->
<!--              ></video>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->




<!--      <div class="section-touch-screen">-->
<!--        <div class="touch-screen-list">-->
<!--          <div class="touch-screen-item pl-100 pr-100">-->
<!--            <div class="product-special-title">-->
<!--              <div class="product-special-title-b">-->
<!--                <h5>6-inch HD</h5>-->
<!--                <h5>touchscreen</h5>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="product-special-title">-->
<!--              <div class="product-detail-text1">-->
<!--                <p class="txt">High-resolution display remains visible even under</p>-->
<!--                <p class="txt">surgical lighting</p>-->
<!--                <p class="txt">Responsive touchscreen compatible with gloved</p>-->
<!--                <p class="txt">hands</p>-->
<!--                <p class="txt">Quick preset interface for faster and more efficient</p>-->
<!--                <p class="txt">workflows</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="touch-screen-item">-->
<!--            <div class="image pr-100 pl-100">-->
<!--              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251219/f055b846712d32b00ca5269fa5fa8cef.png" alt=""/>-->
<!--            </div>-->
<!--            <div class="image pr-100 pl-100">-->
<!--              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251219/bc98871ecd2c3c870d358a7ff2f71fd5.png" alt=""/>-->
<!--            </div>-->
<!--          </div>-->

<!--        </div>-->

<!--        <div class="section-packaging pl-100 pr-100">-->
<!--          <div class="product-special-title">-->
<!--            <div class="product-special-title-b">-->
<!--              <h5>Packaging that lightens</h5>-->
<!--              <h5>the planet’s load</h5>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="product-detail-text1" >-->
<!--            <p class="txt">Our commitment to the Earth starts with what we</p>-->
<!--            <p class="txt">leave behind. By replacing plastics with high-</p>-->
<!--            <p class="txt">packaging that provides uncompromising protection</p>-->
<!--            <p class="txt">for your device today—while ensuring it gracefully</p>-->
<!--            <p class="txt">returns to nature tomorrow.</p>-->

<!--            <p class="txt">A gift to the Earth, starting with packaging designed</p>-->
<!--            <p class="txt">to disappear.</p>-->
<!--          </div>-->

<!--          <div class="image">-->
<!--            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260123/69f6de3ab94b8a658f9cfe0bff2a6bc6.jpg" alt=""></img>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="keep-exploring pl-100 pr-100">-->
<!--          <div class="product-special-title">-->
<!--            <div class="product-special-title-b">-->
<!--              <h5>Keep exploring EndoTG Series</h5>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="keep-exploring-container">-->
<!--            <div class="mode-list">-->
<!--              <div class="mode-item">-->
<!--                <div class="mode-item-box">-->
<!--                  <div class="image">-->
<!--                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260124/5df5bda98ad17adcec553915da520fa2.png" alt=""/>-->
<!--                  </div>-->
<!--                  <h5 class="title txt-center">Endo GT mini</h5>-->
<!--                </div>-->
<!--                <p class="txt txt-center">-</p>-->
<!--                <p class="txt txt-center">-</p>-->
<!--                <p class="txt txt-center">-</p>-->
<!--              </div>-->
<!--              <div class="mode-item">-->
<!--                <div class="mode-item-box">-->
<!--                  <div class="image">-->
<!--                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251219/7fba53edbab0d33e9b0f3f0d0cf05746.png" alt=""/>-->
<!--                  </div>-->
<!--                  <h5 class="title txt-center">Endo GT</h5>-->
<!--                </div>-->
<!--                <p class="txt">Built-in AL in handpiece</p>-->
<!--                <p class="txt txt-center">-</p>-->
<!--                <p class="txt txt-center">-</p>-->
<!--              </div>-->
<!--              <div class="mode-item">-->
<!--                <div class="mode-item-box">-->
<!--                  <div class="image">-->
<!--                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251219/7fba53edbab0d33e9b0f3f0d0cf05746.png" alt=""/>-->
<!--                  </div>-->
<!--                  <h5 class="title txt-center">Endo GT Pro</h5>-->
<!--                </div>-->
<!--                <p class="txt">Built-in AL in handpiece</p>-->
<!--                <p class="txt">Built-in AL in main unit</p>-->
<!--                <p class="txt">Wireless foot pedal</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <i class="line"></i>-->

<!--            <div class="mode-function mode-list">-->
<!--              <div class="mode-function-item mode-item">-->
<!--                <p class="title">Endo GT Mini</p>-->
<!--                <p class="txt">Contra-angle * 2</p>-->
<!--                <p class="txt small">(one with LED / another one smaller without LED)</p>-->
<!--                <p class="txt mt-4">Handpiece * 1</p>-->
<!--                <p class="txt">Main unit * 1</p>-->
<!--                <p class="txt">-</p>-->
<!--                <p class="txt">Power adapter * 1</p>-->
<!--                <p class="txt">-</p>-->
<!--                <p class="txt">-</p>-->
<!--                <p class="txt">-</p>-->
<!--                <p class="txt">Charging base * 1</p>-->
<!--                <p class="txt">-</p>-->
<!--                <p class="txt">-</p>-->
<!--                <p class="txt">Spray nozzle * 1</p>-->
<!--                <p class="txt">Disposable sleeve * 10</p>-->
<!--                <p class="txt">-</p>-->
<!--                <p class="txt">Instructions for use * 1</p>-->
<!--                <p class="txt">Packing list * 1</p>-->
<!--              </div>-->
<!--              <div class="mode-function-item mode-item">-->
<!--                <p class="title">Endo GT</p>-->
<!--                <p class="txt">Contra-angle * 2</p>-->
<!--                <p class="txt small">(one with LED / another one smaller without LED)</p>-->
<!--                <p class="txt mt-4">Handpiece * 1</p>-->
<!--                <p class="txt">Main unit * 1</p>-->
<!--                <p class="txt">-</p>-->
<!--                <p class="txt">Power adapter * 1</p>-->
<!--                <p class="txt">File clip * 4</p>-->
<!--                <p class="txt">Lip hook * 5</p>-->
<!--                <p class="txt">Touch probe * 2</p>-->
<!--                <p class="txt">Charging base * 1</p>-->
<!--                <p class="txt">Measuring cable * 1</p>-->
<!--                <p class="txt">Tester * 1</p>-->
<!--                <p class="txt">Spray nozzle * 1</p>-->
<!--                <p class="txt">Disposable sleeve * 10</p>-->
<!--                <p class="txt">Protective silicone cover * 2</p>-->
<!--                <p class="txt">Instructions for use * 1</p>-->
<!--                <p class="txt">Packing list * 1</p>-->
<!--              </div>-->
<!--              <div class="mode-function-item mode-item">-->
<!--                <p class="title">Endo GT Pro</p>-->
<!--                <p class="txt">Contra-angle * 2</p>-->
<!--                <p class="txt small">(one with LED / another one smaller without LED)</p>-->
<!--                <p class="txt mt-4">Handpiece * 1</p>-->
<!--                <p class="txt">Main unit * 1</p>-->
<!--                <p class="txt">Wireless foot pedal * 1</p>-->
<!--                <p class="txt">Power adapter * 2</p>-->
<!--                <p class="txt">File clip * 4</p>-->
<!--                <p class="txt">Lip hook * 5</p>-->
<!--                <p class="txt">Touch probe * 2</p>-->
<!--                <p class="txt">Charging base * 1</p>-->
<!--                <p class="txt">Measuring cable * 1</p>-->
<!--                <p class="txt">Tester * 1</p>-->
<!--                <p class="txt">Spray nozzle * 1</p>-->
<!--                <p class="txt">Disposable sleeve * 10</p>-->
<!--                <p class="txt">Protective silicone cover * 2</p>-->
<!--                <p class="txt">Instructions for use * 1</p>-->
<!--                <p class="txt">Packing list * 1</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <i class="line mt-114" ></i>-->

<!--            <div class="specifications-container">-->
<!--              <div class="product-special-title">-->
<!--                <div class="product-special-title-b">-->
<!--                  <h5>Specifications</h5>-->
<!--                </div>-->
<!--              </div>-->

<!--              <div class="specifications-list ">-->
<!--                <div class="specifications-item">-->
<!--                  <p class="txt">Speed</p>-->
<!--                  <p class="title">50-3000 rpm</p>-->
<!--                </div>-->
<!--                <div class="specifications-item">-->
<!--                  <p class="txt">Torque</p>-->
<!--                  <p class="title">0.4-5.0 N·cm</p>-->
<!--                </div>-->
<!--                <div class="specifications-item">-->
<!--                  <p class="txt">Ratio of contra-angle</p>-->
<!--                  <p class="title">6:1</p>-->
<!--                </div>-->
<!--                <div class="specifications-item">-->
<!--                  <p class="txt">Integrated LED</p>-->
<!--                  <p class="title">≥8000 lux</p>-->
<!--                </div>-->
<!--                <div class="specifications-item">-->
<!--                  <p class="txt">Working modes</p>-->
<!--                  <p class="title">EAL, CW, CCW, REC (SGP), TorqueSense</p>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--&lt;!&ndash;      <div class="section-bottom-banner">&ndash;&gt;-->
<!--&lt;!&ndash;        <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251219/39eb92c8dc035af700c6690c0bdf2113.jpg" alt=""/>&ndash;&gt;-->
<!--&lt;!&ndash;      </div>&ndash;&gt;-->

<!--      <video-modal ref="videoModalRef"></video-modal>-->
<!--    </div>-->
    <specialEndo ></specialEndo>

    <hpfooter></hpfooter>
  </div>
</template>

<script>

// import circularProgress from "../components/endo/progress-circle.vue";
// import endoButton from '../components/endo/button.vue'
// import videoModal from '../components/endo/video-modal.vue'

// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
import hpheader from '../../../common/hpheader.vue'
import hpfooter from '../../../common/hpfooter.vue'
import positionBar from '../../../components/ph-position-bar.vue'
import {session} from "../../../storage/storage"
// gsap.registerPlugin(ScrollTrigger);
import specialEndo from '@/components/special/mobile/endo/index.vue'

//
  export default {
    components: {
      positionBar,
      hpfooter,
      hpheader,
      specialEndo,
    },
    data() {
      return {
        showHeader: true,
        is_mounted: false,
        productc_nav: false,
        videoProgress: 0,
        videoIsPlaying: true,
        contraAngleSliderValue: 0,
        valuid:1,
        videoList: [
          {
            ref: 'previewVideoRef',
            progress: 0,
            playing: false,
            video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/796e824f5145403708972671759/oOkSHUvpaWoA.mp4',
            previewVideo: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/5b5a06b85145403713209442445/sIPEE86eV5IA.mp4',
          },
          {
            ref: 'productVideoRef',
            progress: 0,
            playing: false,
            video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/473fa3e65145403709194452288/1J1BHLRNKowA.mp4',
            previewVideo: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/56a834465145403714488171756/x2huXQ5iuEgA.mp4'
          },
          {
            ref: 'stepVideo1Ref',
            progress: 0,
            playing: false,
            video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/fcf2e8ce5145403709301500262/VQfT2rFuHmMA.mp4'
          },
          {
            ref: 'stepVideo2Ref',
            progress: 0,
            playing: false,
            video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/f8eb701c5145403709301390188/araDpiDEcgAA.mp4'
          },
          {
            ref: 'stepVideo3Ref',
            progress: 0,
            playing: false,
            video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/cbbea11d5145403713214694823/WqHRUq4qiicA.mp4'
          },
          {
            ref: 'gPreviewVideoRef',
            progress: 0,
            playing: false,
            video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/7e22f7285145403709306548865/CUggH2zVoPcA.mp4',
            previewVideo: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/58c945285145403714488245774/kUesAPotdfcA.mp4'
          },
          {
            ref: 'gModeVideoRef',
            progress: 0,
            playing: false,
            video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/4284650e5145403715046386999/FtrnNAqgx8cA.mp4'
          },
          {
            ref: 'buildFileVideoRef',
            progress: 0,
            playing: false,
            video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/920d40355145403714482561310/sIrOk0GeFWkA.mp4'
          },
          {
            ref: 'magneticRef',
            progress: 0,
            playing: false,
            video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/5580c4a05145403714226624469/IPJ9sdHHQnkA.mp4'
          },
        ],
        // videoList:[
        //   {
        //     ref: 'previewVideoRef',
        //     progress: 0,
        //     playing: false,
        //     video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/5b5a06b85145403713209442445/sIPEE86eV5IA.mp4'
        //   },
        //   {
        //     ref: 'productVideoRef',
        //     progress: 0,
        //     playing: false,
        //     video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/56a834465145403714488171756/x2huXQ5iuEgA.mp4'
        //   },
        //   {
        //     ref: 'stepVideo1Ref',
        //     progress: 0,
        //     playing: false,
        //     video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/fcf2e8ce5145403709301500262/VQfT2rFuHmMA.mp4'
        //   },
        //   {
        //     ref: 'stepVideo2Ref',
        //     progress: 0,
        //     playing: false,
        //     video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/f8eb701c5145403709301390188/araDpiDEcgAA.mp4'
        //   },
        //   {
        //     ref: 'stepVideo3Ref',
        //     progress: 0,
        //     playing: false,
        //     video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/8feaae925145403709303205442/Mu8FwDEdsmMA.mp4'
        //   },
        //   {
        //     ref: 'gPreviewVideoRef',
        //     progress: 0,
        //     playing: false,
        //     video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/58c945285145403714488245774/kUesAPotdfcA.mp4'
        //   },
        //   {
        //     ref: 'gModeVideoRef',
        //     progress: 0,
        //     playing: false,
        //     video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/a960dc375145403713224008980/hruOoezPeoUA.mp4'
        //   },
        //   {
        //     ref: 'buildFileVideoRef',
        //     progress: 0,
        //     playing: false,
        //     video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/920d40355145403714482561310/sIrOk0GeFWkA.mp4'
        //   },
        //   {
        //     ref: 'magneticRef',
        //     progress: 0,
        //     playing: false,
        //     video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/5580c4a05145403714226624469/IPJ9sdHHQnkA.mp4'
        //   },
        // ],
        contraAngleBanner: [
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/c6067e872b55e5d6acf177939ac5a0c8.jpg',
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/b59ba70340db05e588244f83f18a0f8e.jpg',
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/493cc727e1a9b5e616f29a2211ac7104.jpg',
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/9ead80eb13be4a13f0f3cdc42285c9ff.jpg',
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/72ce736cd62207015f96a91f83752ce6.jpg',
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/649aa3dd9b0219be20c02dbb3ea41cb4.jpg',
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/040fbcef9345317e6d5f8b63634507eb.jpg',
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/8238944342b81f5b8134ce2b715286e7.jpg',
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/6d2c31c66743625370ef787fb2ec1b27.jpg',
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/de71d210ca45ff166b222da3732253a6.jpg',
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/ab90e7a6d3975e0a29c92cf0b6a31417.jpg',
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/0c819732e2b2468b7fca309e559f25d0.jpg',
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/16a6ce0e7b967e2f87251c7bad80659e.jpg',
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/d280151d0cb8197d4aa42a787c454db4.jpg',
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/ec6e696ef61b2e74fd5180921dd96b63.jpg',
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/e6d25395da38d05f2d50bb58f900e4ec.jpg',
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/a1956fe4da20f7f1e849500bc86a33c7.jpg',
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/da1db807c80ef7d3cda11b17dba77314.jpg',
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/afc00c7d7b782b7d0d89a67fd164c570.jpg',
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/7fb5b76f81a3d809d1228a704bc74b20.jpg',
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/debef22e218b390390be149c6ff5d2a0.jpg',
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/cb6940cd8b4f2b756961b647d2ac8e88.jpg',
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/c68e77cb7327bb6b434b16d420a86eca.jpg',
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/6e13e064ac62342482f6871cf419acfb.jpg',
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/413f3dbb1a3eea85c927879f1b952ef9.jpg',
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/d73bc851d358422a7fa81b61e8c3e8db.jpg',
          'https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251229/5d117257f053179f6f41ae8d2f60dab5.jpg',
        ],
        positionNav:[
          {
            title:'Home',
            path:'/phhome',
          },
          {
            title:'Product',
            path:'/phproduct',
          },
          {
            title: 'Endo GT Series',
            path: '/ph/special/endo'
          },
        ],
        channel_id:session.get("channel_id") == '' ? 1 : session.get("channel_id"),
        detail: {},
        value: '产品详情',
        hasUserInteraction: false,
      };
    },
    created(){
      this.ress()

      if (!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
        // this.$router.push({path:'/pc/special/endo'})
        // return
      }
    },
    mounted() {
      let _this = this
      this.$nextTick(() => {
        this.is_mounted = true
        _this.$refs.contraAngleAnimationRef.src = _this.contraAngleBanner[_this.contraAngleBanner.length - 1]

        this.videoList.forEach((item, index) => {
            const videoRef = this.$refs[item.ref];
            if (videoRef) {
              // 添加各种加载事件监听

              // videoRef.addEventListener('loadeddata', () => {
              //   const handleFirstInteraction = () => {
              //     this.hasUserInteraction = true;
              //     document.removeEventListener('scroll', handleFirstInteraction);
              //     document.removeEventListener('touchstart', handleFirstInteraction);
              //     this.tryPlayAllVideos();
              //   };
              //   document.addEventListener('scroll', handleFirstInteraction, { once: true });
              //   document.addEventListener('touchstart', handleFirstInteraction, { once: true });
              //   // 等待用户首次交互后再播放（如 scroll、touchstart）
              //   if (!this.hasUserInteraction) {
              //     // 注册一次用户交互事件
              //
              //   }
              // }, { once: true });

              // videoElement.addEventListener('canplay', (e) => {
              //   this.onVideoCanPlay(e, index);
              // });
              //
              // videoElement.addEventListener('canplaythrough', (e) => {
              //   this.onVideoCanPlayThrough(e, index);
              // });
              //
              // videoElement.addEventListener('waiting', (e) => {
              //   this.onVideoWaiting(e, index);
              // });
              //
              // videoElement.addEventListener('playing', (e) => {
              //   this.onVideoPlaying(e, index);
              // });
            }
        });

        setTimeout(() => {
          _this.setupVideoIntersectionObserver()
          // _this.contraAngleAnimation()
        }, 500)
        // document.addEventListener('scroll', this.handleScroll, false)
        //
        // this.$once('hook:beforeDestroy', () => {
        //   document.removeEventListener('scroll', this.handleScroll, false)
        // })
      })
    },
    methods: {
      tryPlayAllVideos() {
        this.videoList.forEach(item => {
          const videoRef = this.$refs[item.ref];
          if (videoRef && !item.playing) {
            videoRef.play().catch(e => {
              console.warn(`[AutoPlay] ${item.ref} 播放失败:`, e);
              // 可降级：显示“点击播放”按钮
              this.showPlayButton = true;
            });
          }
        });
      },
      // togglePlay(index) {
      //   const item = this.videoList[index];
      //   const videoRef = this.$refs[item.ref];
      //   if (item.playing) {
      //     videoRef.pause();
      //   } else {
      //     videoRef.play().catch(e => {
      //       console.error(`${item.ref} 手动播放失败:`, e);
      //       // 提示用户
      //       this.$message.warning('请允许自动播放或点击重试');
      //     });
      //   }
      //   item.playing = !item.playing;
      // },
      onVideoLoadedData(event, index){
        this.$refs[this.videoList[index].ref].play().catch(e => {
          console.log("视频播放失败:", e)
        });
      },
      ress(){
        var html = document.documentElement; //获取根元素
        var designWidth = 750; //设计稿宽度
        //html.clientWidth 视口宽度
        html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
      },
      openVideoModal(url){
        this.$refs.videoModalRef.open(url)
      },
      listenMove(value){
        if(value < this.contraAngleBanner.length){
          this.$refs.contraAngleAnimationRef.src = this.contraAngleBanner[value]
        }
      },
      contraAngleBannerMove(){

      },
      togglePlay(index) {
        this.videoList[index].playing = !this.videoList[index].playing;
        if(this.videoList[index].playing){
          this.$refs[this.videoList[index].ref].play().catch(e => console.log(this.videoList[index].ref + "视频播放失败:", e));
        }else {
          this.$refs[this.videoList[index].ref].pause();
        }
      },
      onImageLoad(){
        // this.initScrollAnimation();
      },
      onImprovedBanner(){
        // this.initImprovedBannerAnimation()
      },
      contraAngleAnimation(){
        const _this = this
        const totalLen = this.contraAngleBanner.length
        gsap.timeline({
          scrollTrigger: {
            trigger: ".contra-angle-banner-animate-box",
            start: `top top`,
            end: `+=500`,
            scrub: true,
            pin: true,
            onEnter: () => {
              _this.showHeader = false
            },
            onLeave: () => {

            },
            onUpdate: (self) => {
              let pic = _this.contraAngleBanner[Math.ceil(self.progress * totalLen) - 1]
              if(pic){
                _this.$refs.contraAngleAnimationRef.src = pic
              }

              if(self.progress == 1 || self.progress == 0){
                _this.showHeader = true
              }else {
                _this.showHeader = false
              }
            }
          }
        })
      },
      initImprovedBannerAnimation(){
        gsap.timeline({
          scrollTrigger: {
            trigger: ".improved-container",
            start: `top top`,
            end: `+=2000`,
            scrub: true,
            pin: true,
            onEnter: () => {
            },
          }
        }).to('.improved-banner-text', {
              opacity: 0
            })
            .to('.improved-background', {
              opacity: 1,
            }, '<')
            .to('.improved-content',{
              y: `-100vh`
            }, '<')
      },
      initScrollAnimation(){
        const _this = this

        const bannerElement = document.querySelector('.banner')

        this.videoList.forEach(item => {
          if(this.$refs[item.ref]){
            this.$refs[item.ref].addEventListener('timeupdate', this.onVideoProgress);
          }
        })
        this.setupVideoIntersectionObserver()

        gsap.timeline({
          scrollTrigger: {
            trigger: ".banner-container",
            start: `top top`,
            end: `+=4000`,
            scrub: true,
            pin: true,
            onEnter: () => {
              if (this.$refs[this.videoList[0].ref]) {
                this.$refs[this.videoList[0].ref].currentTime = 0;
                this.videoList[0].playing = true
                this.$refs[this.videoList[0].ref].play().catch(e => console.log(this.videoList[index].ref + "视频播放失败:", e));
              }
            },
          }
        }).to(this.$refs.previewVideoContainerRef, {
          marginTop: `-${bannerElement.offsetHeight}`,
        }).to(this.$refs.previewVideoTextRef, {
          marginTop: `-${bannerElement.offsetHeight}`,
        }).to(this.$refs.previewVideoBoxRef, {
          background: 'rgba(0, 0, 0, 0)'
        }, "<")
      },
      setupVideoIntersectionObserver() {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && entry.intersectionRatio > 0.3) {
              const index = this.videoList.findIndex(item => this.$refs[item.ref] === entry.target);
              if (index !== -1 && !this.videoList[index].playing && this.hasUserInteraction) {
                this.$refs[this.videoList[index].ref].play().catch(() => {});
                this.videoList[index].playing = true;
              }
            }else {
              const index = this.videoList.findIndex(item => this.$refs[item.ref] === entry.target);
              if (index !== -1 && this.videoList[index].playing) {
                this.$refs[this.videoList[index].ref].pause();
                this.$refs[this.videoList[index].ref].currentTime = 0
                this.videoList[index].playing = false;
              }
            }
          });
        }, { threshold: [0.3] });

        this.videoList.forEach(item => {
          const el = this.$refs[item.ref];
          if (el) observer.observe(el);
        });

        const handleFirstInteraction = () => {
          this.hasUserInteraction = true;
          document.removeEventListener('scroll', handleFirstInteraction);
          document.removeEventListener('touchstart', handleFirstInteraction);
        };
        document.addEventListener('scroll', handleFirstInteraction, { once: true });
        document.addEventListener('touchstart', handleFirstInteraction, { once: true });
        // const observer = new IntersectionObserver((entries) => {
        //   entries.forEach(entry => {
        //     if (entry.intersectionRatio === 0) {
        //       this.videoList.forEach(item => {
        //         if (this.$refs[item.ref] === entry.target && item.playing) {
        //           this.$refs[item.ref].pause();
        //           this.$refs[item.ref].currentTime = 0;
        //           item.playing = false;
        //         }
        //       });
        //     } else if (entry.isIntersecting && entry.intersectionRatio >= 0.1) {
        //       this.videoList.forEach(item => {
        //         if (this.$refs[item.ref] === entry.target && !item.playing) {
        //           item.playing = true;
        //           this.$refs[item.ref].play().catch(e => {
        //             item.playing = false;
        //             console.log(item.ref + "视频播放失败:", e)
        //           });
        //         }
        //       });
        //     }
        //   });
        // }, {
        //   threshold: [0, 0.1, 0.5, 1.0],
        //   rootMargin: '0px'
        // });
        //
        // this.videoList.forEach(item => {
        //   if (this.$refs[item.ref]) {
        //     observer.observe(this.$refs[item.ref]);
        //   }
        // });
        //
        // this.$once('hook:beforeDestroy', () => {
        //   this.videoList.forEach(item => {
        //     if (this.$refs[item.ref]) {
        //       observer.unobserve(this.$refs[item.ref]);
        //     }
        //   });
        // });
      },
      onVideoProgress(event) {
        const video = event.target;
        const currentTime = video.currentTime;
        const duration = video.duration;

        const videoIndex = this.videoList.findIndex(item => {
          return this.$refs[item.ref] === video;
        });

        if (videoIndex !== -1) {
          this.videoList[videoIndex].progress = ((currentTime / duration) * 100).toFixed(2);
        }
      },
      handleScroll() {
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        let head_height = this.$refs.head.getHeaderHeight()
        if (scrollTop > head_height) {
          this.productc_nav = true
          this.scroll_height = scrollTop
        } else {
          this.productc_nav = false
        }
        this.$refs.head.scrollTop_change(scrollTop, 'pcquerys')
      },
      selesac(){
        this.valuid=this.value
        let currentRoute = this.$route;
        let query = {...currentRoute.query}
        if(this.valuid == 3){
          query.download = 1
        }else {
          delete query.download
        }
        this.$router.push({
          path: currentRoute.path,
          query: query
        }).then(() => {
          console.log('Query parameter added or updated.');
        });
      },
    },
    beforeDestroy() {
      ScrollTrigger.getAll().forEach(t => t.kill());
    }
  };
</script>

<style >

</style>
